import styles from './table.module.scss';
import MaterialTable from '@mui/material/Table';
import MaterialTableBody from '@mui/material/TableBody';
import MaterialTableCell from '@mui/material/TableCell';
import MaterialTableContainer from '@mui/material/TableContainer';
import MaterialTableFooter from '@mui/material/TableFooter';
import MaterialTableHead from '@mui/material/TableHead';
import MaterialTablePagination from '@mui/material/TablePagination';
import MaterialTableRow from '@mui/material/TableRow';
import MaterialTableSortLabel from '@mui/material/TableSortLabel';

/* eslint-disable-next-line */
export interface TableProps {
  children: any,
  // classes?: object,
  component?: any,
  padding?: 'checkbox' | 'none' | 'normal',
  size?: 'medium' | 'small',
  stickyHeader?: boolean,
  sx?: any,
  className?: string
}

export interface TableBodyProps {
  children: any,
  // classes?: object,
  component?: any,
  sx?: any
}

export interface TableCellProps {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right',
  children?: any,
  // classes?: object,
  component?: any,
  padding?: 'checkbox' | 'none' | 'normal',
  scope?: string,
  size?: 'small' | 'medium',
  sortDirection?: 'asc' | 'desc' | false,
  sx?: any,
  variant?: 'body' | 'footer' | 'head',
  colSpan?: number
}

export interface TableContainerProps {
  children: any,
  // classes?: object,
  component?: any,
  sx?: any,
  className?: string
}

export interface TableFooterProps {
  children: any,
  // classes?: object,
  component?: any,
  sx?: any
}

export interface TableHeadProps {
  children: any,
  // classes?: object,
  component?: any,
  sx?: any
}

export interface TablePaginationProps {
  count: number,
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void,
  page: number,
  rowsPerPage: number,
  // ActionsComponent?: any,
  // backIconButtonProps?: object,
  // classes?: object,
  component?: any,
  // getItemAriaLabel?: (type: string) => string,
  // labelDisplayedRows?: any,
  // labelRowsPerPage?: ReactNode,
  // nextIconButtonProps?: object,
  // onRowsPerPageChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void,
  // rowsPerPageOptions?: Array<number | { label: string, value: number }>,
  // SelectProps?: object,
  // showFirstButton?: boolean,
  // showLastButton?: boolean,
  // sx?: any
}

export interface TableRowProps {
  children: any,
  // classes?: object,
  component?: any,
  hover?: boolean,
  selected?: boolean,
  sx?: any
}

export interface TableSortLabelProps {
  active?: boolean,
  children: any,
  // classes?: object,
  direction?: 'asc' | 'desc',
  // hideSortIcon?: boolean,
  // IconComponent?: any,
  // sx?: any
  onClick?: (...args: any[]) => void,
}

export function Table(props: TableProps) {
  return (
    <MaterialTable
      padding={props.padding}
      size={props.size}
      component={props.component}
      stickyHeader={props.stickyHeader}
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialTable>
  );
}

export function TableBody(props: TableBodyProps) {
  return (
    <MaterialTableBody
      component={props.component}
      sx={props.sx}>
      {props.children}
    </MaterialTableBody>
  );
}

export function TableCell(props: TableCellProps) {
  return (
    <MaterialTableCell
      align={props.align}
      padding={props.padding}
      sortDirection={props.sortDirection}
      variant={props.variant}
      scope={props.scope}
      component={props.component}
      size={props.size}
      sx={props.sx}
      colSpan={props.colSpan}>
      {props.children}
    </MaterialTableCell>
  );
}

export function TableContainer(props: TableContainerProps) {
  return (
    <MaterialTableContainer
      component={props.component}
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialTableContainer>
  );
}

export function TableFooter(props: TableFooterProps) {
  return (
    <MaterialTableFooter
      component={props.component}
      sx={props.sx}>
      {props.children}
    </MaterialTableFooter>
  );
}

export function TableHead(props: TableHeadProps) {
  return (
    <MaterialTableHead
      component={props.component}
      sx={props.sx}>
      {props.children}
    </MaterialTableHead>
  );
}

export function TablePagination(props: TablePaginationProps) {
  return (
    <MaterialTablePagination
      component={props.component}
      count={props.count}
      onPageChange={props.onPageChange}
      page={props.page}
      rowsPerPage={props.rowsPerPage}>
    </MaterialTablePagination>
  );
}

export function TableRow(props: TableRowProps) {
  return (
    <MaterialTableRow
      sx={props.sx}
      component={props.component}
      hover={props.hover}
      selected={props.selected}>
      {props.children}
    </MaterialTableRow>
  );
}

export function TableSortLabel(props: TableSortLabelProps) {
  return (
    <MaterialTableSortLabel
      active={props.active}
      direction={props.direction}
      onClick={props.onClick}>
      {props.children}
    </MaterialTableSortLabel>
  );
}

export default Table;